var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.blok.icon && _vm.blok.icon.icon) || _vm.validateIconType(_vm.blok.icon_type))?_c('fa-icon',_vm._b({directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}]},'fa-icon',_vm.attributes,false)):_c('span')}
var staticRenderFns = []

export { render, staticRenderFns }